import { z } from 'zod';
export const MasterDataSchema = z.object({
    id: z.string(),
    title: z.string(),
});
export var MasterDataTypesEnum;
(function (MasterDataTypesEnum) {
    MasterDataTypesEnum["TYPES_CONTRIBUTION_INFORMATION"] = "types-contribution-information";
    MasterDataTypesEnum["MOTIFS_CONTRIBUTION_INFORMATION"] = "motifs-contribution-information";
})(MasterDataTypesEnum || (MasterDataTypesEnum = {}));
export const ListMasterDataResponseSchema = z.object({
    _embedded: z.object({
        items: z.array(MasterDataSchema),
    }),
    count: z.number(),
    total: z.number(),
    _links: z.object({}).optional(),
});
//# sourceMappingURL=master-data.js.map